import React from 'react';
import QuickStarts from '../../components/Layout/QuickStarts';

const Index = (props) => {
  return <QuickStarts {...props} />;
};

export default Index;
